import React from "react";
import ThemeTypes from "../../components/navbar/HeaderDropdown/ThemeTypes";

const MobileMoreOption = () => {
  return (
    <>
      <div className="left-side-tablist-mobile-cmp">
        <div
          style={{ justifyContent: "center", padding: "20px" }}
          className="top-header-mobile-cmp"
        >
          Themes
        </div>
        <div className="modal-scroll list-view-mobile-cmp">
            <ThemeTypes />
        </div>
      </div>
    </>
  );
};

export default MobileMoreOption;
